import { useSyncExternalStore } from "react";

/**
 * Which app-wide sheet is open: the bell's notifications, the avatar's
 * account, the gear's configuration. One at a time, opened from anywhere
 * (the Home header, the Leads header), drawn once by MobileSheetsHost.
 */
export type SheetKind = "notifications" | "account" | "configuration";

let open: SheetKind | null = null;
const listeners = new Set<() => void>();
const notify = () => listeners.forEach((fn) => fn());

export function openSheet(kind: SheetKind): void {
  open = kind;
  notify();
}
export function closeSheet(): void {
  if (!open) return;
  open = null;
  notify();
}
const subscribe = (fn: () => void) => {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
};
const get = () => open;
export function useOpenSheet(): SheetKind | null {
  return useSyncExternalStore(subscribe, get, get);
}
